var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, useEffect, } from 'react';
import { faSearch, faChevronLeft, faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import cls from 'classnames';
import { IconTile } from './IconTile';
export function SearchInput(_a) {
    var { id, className, placeholder, value, loading, onChange, onClose, onFocus, onBlur, activated, useDesktopStyles } = _a, props = __rest(_a, ["id", "className", "placeholder", "value", "loading", "onChange", "onClose", "onFocus", "onBlur", "activated", "useDesktopStyles"]);
    const [uuid] = useState(`WhSearch-${Date.now()}`);
    const ref = useRef(null);
    const inputRef = useRef(null);
    const containerId = `${id || uuid}`;
    const inputId = `${containerId}-input`;
    const finalClassName = cls('WhSearch-SearchInput', className, {
        'WhSearch-SearchInput__desktop': useDesktopStyles,
    });
    const change = onChange
        ? (event) => onChange(event.target.value)
        : undefined;
    const close = onClose ? () => onClose() : undefined;
    const clear = onChange ? () => onChange('') : undefined;
    function focus() {
        if (inputRef.current) {
            inputRef.current.click(); // click needed for iOS, iOS does not allow focus if click was not performed before
            inputRef.current.focus();
        }
    }
    useEffect(() => {
        if (activated) {
            focus();
        }
    }, [activated]);
    const icon = loading ? (React.createElement(IconTile, { icon: faCircleNotch, className: "WhSearch-SearchInput__spinner", spin: true, onClick: focus })) : (React.createElement(IconTile, { icon: faSearch, className: "WhSearch-SearchInput__magnifier", onClick: focus }));
    const clearIcon = value && (React.createElement("button", { className: "WhSearch-SearchInput__clear", type: "button", onClick: clear },
        React.createElement(IconTile, { icon: faTimes })));
    return (React.createElement("label", Object.assign({ id: containerId, htmlFor: inputId, className: finalClassName, ref: ref }, props),
        React.createElement(IconTile, { icon: faChevronLeft, role: "button", className: "WhSearch-SearchInput__closeButton", onClick: close }),
        React.createElement("input", { type: "search", ref: inputRef, id: inputId, value: value || '', className: "WhSearch-SearchInput__input", placeholder: placeholder, onChange: change, onFocus: onFocus, onBlur: onBlur }),
        clearIcon,
        icon));
}
//# sourceMappingURL=SearchInput.js.map